import { render, staticRenderFns } from "./JoinEvent.vue?vue&type=template&id=0d06736d&scoped=true"
import script from "./JoinEvent.vue?vue&type=script&lang=js"
export * from "./JoinEvent.vue?vue&type=script&lang=js"
import style0 from "./JoinEvent.vue?vue&type=style&index=0&id=0d06736d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d06736d",
  null
  
)

export default component.exports